module.exports = __webpack_public_path__ + "static/media/level1.9e8b7b39.svg";